import VueGtag, { trackRouter, useGtag} from "vue-gtag-next";
import type { Router } from 'vue-router'
import type { App } from 'vue'

export const initializeAnalytics = (app: App, router: Router, userId?: string) => {
  app.use(VueGtag, {
    property: {
      id: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
    },
    config: {
      user_id: userId
    }
  });
  trackRouter(router);
}

// Eventos de usuario
export const userEvents = {

  userCreated: (userId: string) => {
    const { event } = useGtag()
    event('user_created', {
      user_id: userId,
      event_category: 'user',
      event_label: 'New user registration'
    })
  },
  userLogin: (userId: string) => {
    const { event } = useGtag()
    event('user_login', {
      user_id: userId,
      event_category: 'user',
      event_label: 'User login'
    })
  },
  themeChanged: (theme: string) => {
    const { event } = useGtag()
    event('theme_changed', {
      theme,
      event_category: 'preferences',
      event_label: 'Theme preference'
    })
  }
}

// Eventos de compañía
export const companyEvents = {
  companyCreated: (companyId: string) => {
    const { event } = useGtag()
    event('company_created', {
      company_id: companyId,
      event_category: 'company',
      event_label: 'New company creation'
    })
  },
  companySelected: (companyId: string) => {
    const { event } = useGtag()
    event('company_selected', {
      company_id: companyId,
      event_category: 'company',
      event_label: 'Company switch'
    })
  },
  userInvited: (companyId: string) => {
    const { event } = useGtag()
    event('user_invited', {
      company_id: companyId,
      event_category: 'company',
      event_label: 'User invitation'
    })
  }
}

// Eventos de embarques
export const shipmentEvents = {
  shipmentCreated: (shipmentId: string) => {
    const { event } = useGtag()
    event('shipment_created', {
      shipment_id: shipmentId,
      event_category: 'shipment',
      event_label: 'New shipment'
    })
  },
  shipmentViewed: (shipmentId: string) => {
    const { event } = useGtag()
    event('shipment_viewed', {
      shipment_id: shipmentId,
      event_category: 'shipment',
      event_label: 'Shipment details view'
    })
  },
  shipmentUpdated: (shipmentId: string) => {
    const { event } = useGtag()
    event('shipment_updated', {
      shipment_id: shipmentId,
      event_category: 'shipment',
      event_label: 'Shipment update'
    })
  }
}
